/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowDownRight = createReactComponent("arrow-down-right", "IconArrowDownRight", [
  ["path", { d: "M7 7l10 10", key: "svg-0" }],
  ["path", { d: "M17 8l0 9l-9 0", key: "svg-1" }]
]);

export { IconArrowDownRight as default };
//# sourceMappingURL=IconArrowDownRight.js.map
